import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
    list: [],
    permission: null,
    error: "",
    loading: false,
};

export const GetAllPermission = createAsyncThunk("permission/GetAllPermission", async () => {
    try {
        const { data } = await axios.get(`roles/GetMenuDetails`);
        return data;
    } catch (error) {
        // console.log(error.message);
    }
});

export const GetPermissionsRoleId = createAsyncThunk("roles/getPermissionsRoleId", async (RoleId) => {
    try {
        const { data } = await axios.get(`roles/MenuPermissionGetByRoleId?RoleId=${RoleId}`);
        return data;
    } catch (error) {
        // console.log(error.message);
    }
});



const permissionSlice = createSlice({
    name: "permission",
    initialState,
    reducers: {
        clearPermission: (state) => {
            state.permission = null;
        },
    },
    extraReducers: (builder) => {
        // 1) ====== builders for GetAllPermission ======

        builder.addCase(GetAllPermission.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(GetAllPermission.fulfilled, (state, action) => {
            state.loading = false;
            state.permission = action.payload ||[];
        });

        builder.addCase(GetAllPermission.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        });

        // 1) ====== builders for GetAllPermission ======

        builder.addCase(GetPermissionsRoleId.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(GetPermissionsRoleId.fulfilled, (state, action) => {
            state.loading = false;
            state.permissionByRole = action.payload ||[];
        });

        builder.addCase(GetPermissionsRoleId.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        });


        
    },
});

export default permissionSlice.reducer;
export const { clearPermission } = permissionSlice.actions;
